import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';

import { CardFilter } from '../card-filter/card-filter';

/**
 * Card filter component
 *
 * Usage:
 * <code><pre>
 * // Individual module import
 * import { CardFilterModule } from 'patternfly-ng/card';
 * // Or
 * import { CardFilterModule } from 'patternfly-ng';
 *
 * &#64;NgModule({
 *   imports: [CardFilterModule,...]
 * })
 * export class AppModule(){}
 * </pre></code>
 *
 * Optional:
 * <code><pre>
 * import { CardFilter, CardFilterPosition } from 'patternfly-ng/card';
 * </pre></code>
 */

export class CardFilterComponent implements OnInit {
  /**
   * The card filters
   */
   filters: CardFilter[];

  /**
   * The event emitted when a filter is selected
   */
   onSelect = new EventEmitter();

  private _currentFilter: CardFilter;

  /**
   * The default constructor
   */
  constructor() {
  }

  // Initialization

  /**
   * Setup component configuration upon initialization
   */
  ngOnInit(): void {
    if (this.filters !== undefined && this.filters.length > 0) {
      this.currentFilter = this.filters[0];
      this.filters.forEach((filter) => {
        if (filter.default === true) {
          this.currentFilter = filter;
          return;
        }
      });
    }
  }

  // Actions

  private select($event: CardFilter): void {
    this.currentFilter = $event;
    this.onSelect.emit($event);
  }

  // Accessors

  /**
   * Returns the current filter
   *
   * @returns {CardFilter} The current filter
   */
  get currentFilter(): CardFilter {
    return this._currentFilter;
  }

  /**
   * Sets the current filter
   *
   * @param {CardFilter} filter The current filter
   */
  set currentFilter(filter: CardFilter) {
    this._currentFilter = filter;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  encapsulation: ViewEncapsulation.None,
  selector: 'pfng-card-filter',
  template: `<div class="card-pf-time-frame-filter"><div class="dropdown primary-action" dropdown><button class="btn btn-default dropdown-toggle" type="button" dropdownToggle>{{currentFilter?.title}}<span class="caret"></span></button><ul class="dropdown-menu dropdown-menu-right" role="menu" *dropdownMenu><li role="menuitem" *ngFor="let filter of filters" [ngClass]="{'selected': filter === currentFilter}"><a class="dropdown-item" role="menuitem" tabindex="-1" (click)="select(filter)">{{filter?.title}}</a></li></ul></div></div>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'filters': [{ type: Input },],
'onSelect': [{ type: Output, args: ['onFilterSelect', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
